import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class GA4GeneralApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.GA4General;

  constructor(private payload: {
    event: string,
    gtmCustom?: any,
    label: string,
  }) {
  }

  getPayload(): any {
    const { event, gtmCustom, label } = this.payload;

    return {
      event,
      gtmCustom,
      label,
    };
  }
}
